interface CodeOptionParams {
  active: boolean;
  campaignId: number;
  count: number;
  description: string;
  id: number;
  limit?: number;
}

export default class CodeOption {
  active: boolean;
  campaignId!: number;
  count: number;
  description: string;
  id!: number;
  limit: number | null;

  constructor({ active, campaignId, count, description, id, limit }: CodeOptionParams) {
    this.id = id;
    this.campaignId = campaignId;
    this.active = active;
    this.count = count;
    this.description = description;
    this.limit = limit ?? null;
  }

  static fromJson(data: any) {
    return new CodeOption({
      id: data.id,
      campaignId: data.campaignId,
      active: data.active,
      count: data.count,
      description: data.description,
      limit: data.limit
    });
  }
}

export type CodeOptionMap = {
  [id: number]: CodeOption;
};
